import React from "react";
import { MobileTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, InputAdornment } from "@mui/material";
import { AccessTime } from "@mui/icons-material";
import dayjs from "dayjs";
import 'dayjs/locale/fr';

const TimeTextField = React.memo(
  ({ label, value, onChange, isDark, handleBlur, touched, error, name, column, row, disabled = false }) => {
    const timeValue = value ? dayjs(value, 'HH:mm') : null;

    const handleTimeChange = (newValue) => {
      const timeString = newValue ? dayjs(newValue).format('HH:mm') : '';
      if (name && handleBlur) {
        const syntheticEvent = {
          target: {
            name: name,
            value: timeString,
            type: 'time'
          },
          type: 'change',
          preventDefault: () => {},
          stopPropagation: () => {},
          persist: () => {}
        };
        onChange(syntheticEvent);
      } else {
        onChange(timeString);
      }
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
        <MobileTimePicker
          label={label}
          value={timeValue}
          onChange={handleTimeChange}
          ampm={true}
          disabled={disabled}
          renderInput={(params) => (
            name && name !== "" ? (
              <TextField
                {...params}
                fullWidth
                variant="filled"
                onBlur={handleBlur}
                name={name}
                error={!!touched && !!error}
                helperText={touched && error}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccessTime sx={{ color: isDark ? "black" : "white" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                  gridColumn: column, 
                  gridRow: row,
                  "& .MuiInputLabel-root": {
                    color: isDark ? "black" : "white",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "primary.main",
                  },
                }}
              />
            ) : (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccessTime sx={{ color: isDark ? "black" : "white" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  width: 150,
                  "& .MuiOutlinedInput-root": {
                    color: isDark ? "black" : "white",
                    "& fieldset": { borderColor: isDark ? "black" : "white" },
                    "&:hover fieldset": {
                      borderColor: isDark ? "black" : "white",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: isDark ? "black" : "white",
                    },
                  },
                  "& .MuiInputLabel-root": { color: isDark ? "black" : "white" },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: isDark ? "black" : "white",
                  },
                  "& .MuiSvgIcon-root": { color: isDark ? "black" : "white" },
                }}
              />
            )
          )}
        />
      </LocalizationProvider>
    );
  }
);

export default TimeTextField;
